import { NotFoundError } from 'interface-store';
import { BaseBlockstore } from './base.js';
export class BlackHoleBlockstore extends BaseBlockstore {
    put(key) {
        return key;
    }
    get() {
        throw new NotFoundError();
    }
    has() {
        return false;
    }
    async delete() {
    }
    async *getAll() {
    }
}
//# sourceMappingURL=black-hole.js.map